export enum UserType {
  Tracked = `tracked-user`,
  Mixpanel = `mp-user`,
}
